import { eventEmitter } from "@/utils/event-emitter.js";
import { appState } from "@/utils/state.js";

export function resetGame() {
  //userClick();
  eventEmitter.on("reset", () => {
    const boardArr = document.querySelectorAll(".cell");
    const size = (appState.getState("levelInd") + 1) * 5;
    appState.setState("userInput", Array(size * size).fill(0));
    boardArr.forEach((elem) => {
      elem.classList.toggle("x", false);
      elem.classList.toggle("dark", false);
    });
    eventEmitter.emit("levelChange");
    eventEmitter.emit("templateChange");
  });
}
